import React from "react";
import { Loading } from '../shared/constants/texts.js';

export const Cases = (props) => {

  return (
    <div id="cases" style={{ 
      padding: '50px 0',
      background: '#ffffff'
    }}>
      <div className="container">
        <div className="section-title">
          <h2>Cases de Sucesso</h2>
          <p>
            Conheça alguns projetos que desenvolvemos e os resultados alcançados para nossos clientes. 
            Nomes e detalhes específicos foram alterados para preservar a confidencialidade.
          </p>
        </div>
        
        <div className="row">
          {props.data ?
          props.data.map((caseItem, index) => (
            <div key={`case-${index}`} className="col-md-12" style={{ marginBottom: '20px' }}>
              <div style={{
                padding: '20px',
                background: '#fff',
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.3s ease'
              }}
              className="case-card"
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 20px 40px -10px rgba(59, 130, 246, 0.2)';
                e.currentTarget.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
              >
                <div className="row">
                  <div className="col-md-8">
                    <div style={{ marginBottom: '12px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                        <i 
                          className={caseItem.icon}
                          style={{
                            fontSize: '24px',
                            color: '#3b82f6',
                            marginRight: '10px',
                            background: 'rgba(59, 130, 246, 0.1)',
                            padding: '8px',
                            borderRadius: '8px',
                            width: '40px',
                            height: '40px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        ></i>
                        <div>
                          <h3 style={{
                            fontSize: '18px',
                            fontWeight: '700',
                            color: '#1e293b',
                            marginBottom: '2px'
                          }}>
                            {caseItem.title}
                          </h3>
                          <div style={{ fontSize: '12px', color: '#64748b' }}>
                            <strong>{caseItem.client}</strong> • {caseItem.industry}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style={{ marginBottom: '10px' }}>
                      <h4 style={{
                        fontSize: '13px',
                        fontWeight: '700',
                        color: '#334155',
                        marginBottom: '4px'
                      }}>
                        Desafio
                      </h4>
                      <p style={{
                        fontSize: '13px',
                        lineHeight: '1.4',
                        color: '#475569',
                        marginBottom: '0'
                      }}>
                        {caseItem.challenge}
                      </p>
                    </div>

                    <div style={{ marginBottom: '10px' }}>
                      <h4 style={{
                        fontSize: '13px',
                        fontWeight: '700',
                        color: '#334155',
                        marginBottom: '4px'
                      }}>
                        Solução
                      </h4>
                      <p style={{
                        fontSize: '13px',
                        lineHeight: '1.4',
                        color: '#475569',
                        marginBottom: '0'
                      }}>
                        {caseItem.solution}
                      </p>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div style={{
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      padding: '16px',
                      borderRadius: '10px',
                      color: '#fff'
                    }}>
                      <h4 style={{
                        fontSize: '13px',
                        fontWeight: '700',
                        color: '#fff',
                        marginBottom: '10px'
                      }}>
                        Resultados
                      </h4>
                      <ul style={{
                        listStyle: 'none',
                        padding: '0',
                        margin: '0'
                      }}>
                        {caseItem.results.map((result, i) => (
                          <li key={`result-${i}`} style={{
                            fontSize: '12px',
                            lineHeight: '1.3',
                            marginBottom: '8px',
                            paddingLeft: '18px',
                            position: 'relative',
                            color: 'rgba(255,255,255,0.95)'
                          }}>
                            <i 
                              className="fa-solid fa-check"
                              style={{
                                position: 'absolute',
                                left: '0',
                                top: '1px',
                                fontSize: '9px',
                                background: 'rgba(255,255,255,0.2)',
                                width: '14px',
                                height: '14px',
                                borderRadius: '3px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            ></i>
                            {result}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>

                {/* <div style={{
                  marginTop: '12px',
                  paddingTop: '12px',
                  borderTop: '1px solid #e2e8f0'
                }}>
                  <div style={{
                    fontSize: '11px',
                    color: '#64748b',
                    fontWeight: '600',
                    marginBottom: '6px'
                  }}>
                    Tecnologias
                  </div>
                  <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                    {caseItem.technologies.map((tech, i) => (
                      <span key={`tech-${i}`} style={{
                        background: 'rgba(59, 130, 246, 0.1)',
                        color: '#3b82f6',
                        padding: '3px 8px',
                        borderRadius: '5px',
                        fontSize: '10px',
                        fontWeight: '600',
                        border: '1px solid rgba(59, 130, 246, 0.2)'
                      }}>
                        {tech}
                      </span>
                    ))}
                  </div>
                </div> */}
              </div>
            </div>
          )): Loading}
        </div>

        <div className="row" style={{ marginTop: '20px' }}>
          <div className="col-md-12 text-center">
            <div style={{
              padding: '20px',
              background: '#f8fafc',
              borderRadius: '10px',
              borderLeft: '4px solid #3b82f6'
            }}>
              <p style={{
                fontSize: '14px',
                color: '#475569',
                marginBottom: '10px',
                fontWeight: '500'
              }}>
                Quer ver seu projeto se tornar nosso próximo case de sucesso?
              </p>
              <a 
                href="#contact" 
                className="btn btn-custom"
                style={{ display: 'inline-block' }}
              >
                Entre em contato
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
